/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'download': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M3.3 28.6a2.3 2.3 0 0 1 2.3 2.3v9.2a2.3 2.3 0 0 0 2.3 2.3h32.2a2.3 2.3 0 0 0 2.3-2.3v-9.2a2.3 2.3 0 1 1 4.6 0v9.2a6.9 6.9 0 0 1-6.9 6.9H7.9A6.9 6.9 0 0 1 1 40.1v-9.2a2.3 2.3 0 0 1 2.3-2.3z"/><path pid="1" fill-rule="evenodd" clip-rule="evenodd" d="M10.87 17.77c.9-.9 2.36-.9 3.26 0L24 27.65l9.87-9.88a2.3 2.3 0 0 1 3.26 3.26l-11.5 11.5c-.9.9-2.36.9-3.26 0l-11.5-11.5a2.3 2.3 0 0 1 0-3.26z"/><path pid="2" fill-rule="evenodd" clip-rule="evenodd" d="M24 1a2.3 2.3 0 0 1 2.3 2.3v27.6a2.3 2.3 0 1 1-4.6 0V3.3A2.3 2.3 0 0 1 24 1z"/>'
  }
})
